// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Erster Anmeldevorgang mit einem Startpasswort vom Admin: hier vergibt das
// Mitglied sein eigenes. Kein Weg an dieser Seite vorbei, solange
// users.must_change_password gesetzt ist (siehe ProtectedRoute).
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { pb } from "@/lib/pb"
import { currentUser, login, logout } from "@/lib/auth"
import { toast } from "@/lib/toast"

export default function PasswortWechselPage() {
  const navigate = useNavigate()
  const user = currentUser()
  const [alt, setAlt] = useState("")
  const [neu, setNeu] = useState("")
  const [neu2, setNeu2] = useState("")
  const [error, setError] = useState("")
  const [busy, setBusy] = useState(false)

  async function speichern(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    if (neu !== neu2) { setError("Die beiden neuen Passwörter stimmen nicht überein."); return }
    if (!user) return
    setBusy(true)
    try {
      // Passwort und Zwang in EINEM Zug: die Regel lässt das Lösen des Zwangs
      // nur zusammen mit einem neuen Passwort zu (Migration 22) — sonst könnte
      // man das Startpasswort per Schnittstelle einfach behalten.
      await pb.collection("users").update(user.id, {
        oldPassword: alt, password: neu, passwordConfirm: neu2, must_change_password: false,
      })
      // PocketBase macht die alte Anmeldung ungültig — direkt neu anmelden,
      // damit das Mitglied nicht zweimal tippen muss. Benutzername zuerst:
      // neue Konten haben oft gar keine E-Mail mehr.
      await login(String(user.username || user.email), neu)
      toast("Passwort gesetzt – willkommen bei fitHub ✓")
      navigate("/start", { replace: true })
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : ""
      setError(msg.includes("schwach")
        ? msg
        : "Das hat nicht geklappt. Startpasswort korrekt? Neues Passwort: mind. 10 Zeichen mit Ziffer und Sonderzeichen.")
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <header className="app-header">
        <p className="eyebrow">fitHub</p>
        <h1>Passwort setzen</h1>
      </header>
      <div className="wrap" style={{ maxWidth: 420 }}>
        <form className="card" style={{ marginTop: 24 }} onSubmit={speichern}>
          <p className="hint" style={{ margin: "0 0 12px" }}>
            Du hast ein Startpasswort bekommen. Vergib jetzt dein eigenes – danach kennt es nur noch du.
          </p>

          <label htmlFor="pw-alt">Startpasswort</label>
          <input id="pw-alt" type="password" autoComplete="current-password" required
            value={alt} onChange={(e) => setAlt(e.target.value)} autoFocus />

          <label htmlFor="pw-neu">Dein neues Passwort (≥10 Zeichen, 1 Ziffer, 1 Sonderzeichen)</label>
          <input id="pw-neu" type="password" autoComplete="new-password" required
            value={neu} onChange={(e) => setNeu(e.target.value)} />

          <label htmlFor="pw-neu2">Neues Passwort wiederholen</label>
          <input id="pw-neu2" type="password" autoComplete="new-password" required
            value={neu2} onChange={(e) => setNeu2(e.target.value)} />

          {error && <p className="form-error" role="alert">{error}</p>}

          <button className="save" type="submit" disabled={busy}>
            {busy ? "Speichert…" : "Passwort setzen"}
          </button>
        </form>
        <p className="hint" style={{ textAlign: "center" }}>
          <button type="button" className="plan-del-link" style={{ margin: "12px auto 0" }}
            onClick={() => { logout(); navigate("/login", { replace: true }) }}>
            Abmelden
          </button>
        </p>
      </div>
    </>
  )
}
